/**
 * 69.62 step 4 (ARCHITECTURE §5.31): a hot rescue's steps as the host's note lines (game/actionHost.ts), from the Match's
 * `rescue*` events — told to the rescuing side only, its commander's rescues and a person's call alike. Null when the viewer is
 * not told.
 */
export type RescueBeatEvent = { kind: 'rescueCalled' | 'rescueLift' | 'rescueSmoke' | 'rescueDone' | 'rescueAborted'; team: number; brought?: number[]; reason?: string };

export function rescueBeat(e: RescueBeatEvent, team: number | null): string | null {
  if (team !== null && e.team !== team) return null;
  switch (e.kind) {
    case 'rescueCalled': return 'Hot rescue: the gunship is going in over the enemy';
    case 'rescueLift': return 'Hot rescue: the gunship is on station, the lift is going in';
    case 'rescueSmoke': return 'Hot rescue: green smoke at the landing zone';
    case 'rescueDone': {
      const n = e.brought?.length ?? 0;
      return n ? `Hot rescue done: ${n} brought out` : 'Hot rescue done: nobody brought out';
    }
    case 'rescueAborted': {
      const why = e.reason ? `: ${e.reason.charAt(0).toLowerCase()}${e.reason.slice(1)}` : '', n = e.brought?.length ?? 0;
      return `Hot rescue given up${why}${n ? ` (${n} aboard)` : ''}`;   // (the lift turned home with whoever had boarded)
    }
  }
}
